import React, { Fragment } from 'react';
import styles from './ReportSummaryCard.module.scss';
import { SFCard } from 'sfui';
import { SummaryInfoList } from './SummaryInfoList/SummayInfoList';
import { SummaryInfoListItem } from './SummaryInfoList/SummaryInfoListItem/SummaryInfoListItem';

export interface ContactSummaryType {
  citizens: number;
  officers: number;
}

export interface CadSummaryType {
  subjects: number;
  units: number;
  officers: number;
  reportingPerson: number;
}

export interface ReportCardSummaryProps {
  className?: string;
  contactSummary?: ContactSummaryType;
  cadSummary?: CadSummaryType | null;
}

export const ReportSummaryCard = ({
  className = '',
  contactSummary,
  cadSummary
}: ReportCardSummaryProps): React.ReactElement<ReportCardSummaryProps> => {
  const twoColumns = !!cadSummary && !!contactSummary;

  return (
    <SFCard
      className={`${styles.reportSummaryCard} ${twoColumns ? styles.twoColumns : ''} ${className}`}
      containerClassName={styles.reportCardSummaryContainer}
      sfElevation={1}
    >
      {cadSummary && (
        <SummaryInfoList title="CAD">
          <SummaryInfoListItem label="Subjects" value={cadSummary.subjects} />
          <SummaryInfoListItem
            label={`Units (${cadSummary.officers} Officers)`}
            value={cadSummary.units}
          />
          <SummaryInfoListItem
            label="Reporting Person"
            value={cadSummary.reportingPerson}
          />
        </SummaryInfoList>
      )}
      {contactSummary && (
        <Fragment>
          {cadSummary && <div className={styles.verticalDivider} />}
          <SummaryInfoList title="Contact">
            <SummaryInfoListItem
              label="Citizens"
              value={contactSummary.citizens}
            />
            <SummaryInfoListItem
              label="Officers"
              value={contactSummary.officers}
            />
          </SummaryInfoList>
        </Fragment>
      )}
    </SFCard>
  );
};
